import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TruecallerPopupComponent } from './truecaller-popup.component';

@NgModule({
  declarations: [TruecallerPopupComponent],
  exports: [TruecallerPopupComponent],
  imports: [
    CommonModule
  ]
})
export class TruecallerPopupModule { }
